import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { VACCINATION_STATUS_ID_KEY } from '@portal/common/models/data-key';
import { DropdownOption } from '@portal/common/types';

import { getEntityHierarchies } from '../../store/data-explorer/selectors';
import ChartHierarchicalDropdown from '../ChartHierarchicalDropdown';

type Props = React.ComponentPropsWithoutRef<typeof ChartHierarchicalDropdown>;

const optionLabelGetter = (o) => o.label;
const optionValueGetter = (o) => o.value;

const VaccinationStatusDropdown = (props: Props) => {
    const entityHierarchies = useSelector(getEntityHierarchies);

    const sortVaccinationStatusOptions = useCallback(
        (options: DropdownOption[]): DropdownOption[] => {
            return options.sort((a, b) => {
                const aItem = entityHierarchies.vaccinationStatuses?.find((h) => h.id === a.value);
                const bItem = entityHierarchies.vaccinationStatuses?.find((h) => h.id === b.value);
                return aItem.sort_order - bItem.sort_order;
            });
        },
        [entityHierarchies.vaccinationStatuses]
    );

    const loadHierarchy = useCallback(
        () => Promise.resolve(entityHierarchies.vaccinationStatuses),
        [entityHierarchies.vaccinationStatuses]
    );

    return (
        <ChartHierarchicalDropdown
            {...props}
            filterKey={VACCINATION_STATUS_ID_KEY}
            rootLevel={0}
            showPrefix={false}
            useLetterPrefix={false}
            loadHierarchy={loadHierarchy}
            optionLabelGetter={optionLabelGetter}
            optionValueGetter={optionValueGetter}
            preprocessOptions={sortVaccinationStatusOptions}
        />
    );
};

export default VaccinationStatusDropdown;
